import gsap from "gsap";

export const header = () => {
  const mv = document.querySelector(".js-mv");
  const header = document.querySelector(".js-header");
  const menu = document.querySelector(".js-menu");
  const menuBtn = document.querySelector(".js-header-menu-btn");

  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;

    if (mv) {
      // MVの高さ分スクロールしたらヘッダーを表示する
      if (currentScrollY > mv.clientHeight) {
        header.classList.add("is-fixed");
        menu.classList.add("is-fixed");
        menuBtn.classList.add("is-fixed");
      }

      if (currentScrollY < mv.clientHeight) {
        if (lastScrollY >= mv.clientHeight && currentScrollY < lastScrollY) {
          gsap.fromTo(
            header,
            {
              duration: 0.3,
              autoAlpha: 1,
            },
            {
              autoAlpha: 0,
              onComplete: () => {
                header.removeAttribute("style");
                header.classList.add("is-hidden");
                header.classList.remove("is-visible");
                header.classList.remove("is-fixed");
              },
            }
          );

          gsap.fromTo(
            menu,
            {
              duration: 0.3,
              autoAlpha: 1,
            },
            {
              autoAlpha: 0,
              onComplete: () => {
                menu.removeAttribute("style");
                menu.classList.add("is-hidden");
                menu.classList.remove("is-visible");
                menu.classList.remove("is-fixed");
              },
            }
          );

          gsap.fromTo(
            menuBtn,
            {
              duration: 0.3,
              autoAlpha: 1,
            },
            {
              autoAlpha: 0,
              onComplete: () => {
                menuBtn.removeAttribute("style");
                menuBtn.classList.add("is-hidden");
                menuBtn.classList.remove("is-visible");
                menuBtn.classList.remove("is-fixed");
              },
            }
          );
        }
      } else {
        if (currentScrollY > lastScrollY) {
          // 下にスクロール → ヘッダーを非表示にする
          header.classList.remove("is-visible");
          header.classList.add("is-hidden");
          header.classList.add("is-down");

          menu.classList.remove("is-visible");
          menu.classList.add("is-hidden");
          menu.classList.add("is-down");

          menuBtn.classList.remove("is-visible");
          menuBtn.classList.add("is-hidden");
          menuBtn.classList.add("is-down");
        } else {
          // 上にスクロール → ヘッダーを表示する
          header.classList.remove("is-hidden");
          header.classList.remove("is-down");
          header.classList.add("is-visible");

          menu.classList.remove("is-hidden");
          menu.classList.remove("is-down");
          menu.classList.add("is-visible");

          menuBtn.classList.remove("is-hidden");
          menuBtn.classList.remove("is-down");
          menuBtn.classList.add("is-visible");
        }
      }
    }

    lastScrollY = currentScrollY;
  });
};
